import { lazy } from "react";
import { RouteConfig } from "../../../types/RouteConfig";

export const unitPremiseDetailsRoute: RouteConfig<'with-page'> = {
    name: 'Unit Details',
    path: '/unit-premises/:unitId/details',
    context: 'member',
    page: lazy(() => import('.')),
    flags: ['member-route'],
}